/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FetchData } from 'app/shared/generalMethods';

@Component({
  selector: 'app-admin-detail',
  templateUrl: './admin-detail.component.html',
  styleUrls: ['./admin-detail.component.scss']
})
export class AdminDetailComponent implements OnInit {
  userRecord: any;
  dataSource: any[] = [];
  dataSourceStaff: any[] = [];
  isStaffView = false;

  constructor(
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _fetchData: FetchData
  ) {}

  ngOnInit(): void {
    this._fetchData.getLocalStorage();
    this.loadAdminAndStaffData();
  }

  loadAdminAndStaffData(): void {
    const adminList = this._fetchData.data?.lstAdministratorData || [];
    const staffList = this._fetchData.data?.lstStaffData || [];

    if (adminList.length > 0) {
      this.dataSource = [...adminList];
      this.dataSourceStaff = staffList.filter((staff: any) =>
        adminList.some((admin: any) => admin.Id === staff.Administrator__c)
      );
      this.isStaffView = false;
    } else {

      this.dataSource = staffList.map((staff: any) => ({
        ...staff,
        Administrator_Name__c: staff.Administrator__r?.Administrator_Name__c,
        Email__c: staff.Administrator__r?.Email__c,
        Phone__c: staff.Administrator__r?.Phone__c,
        Role__c: staff.Administrator__r?.Role__c,
        Town_City__c: staff.Administrator__r?.Town_City__c
      }));

      this.dataSourceStaff = [...staffList];
      this.isStaffView = true;
    }
  }

  onNameClick(admin: any): void {
    if (!this.isStaffView && admin?.Id) {
      this._router.navigate(['/admin-profile', admin.Id]);
      this._snackBar.open(`Viewing details for ${admin.Administrator_Name__c}`, 'Close', {
        duration: 3000
      });
    }
  }

  navigateToStaffDetail(staff: any): void {
    if (staff?.Id) {
      this._router.navigate(['/staff-detail', staff.Id]);
      this._snackBar.open(`Viewing details for ${staff.Staff_Name__c}`, 'Close', {
        duration: 3000
      });
    }
  }
}
